import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class ElektroleitungenJahr extends AbstractRequirementMapper {
  protected frontendKey = 'sanierungen.elektroleitungenJahr';

  public getValues(): number[] {
    return super.getValues().map((v) => Number.parseInt(<string>v, 10));
  }
}
